import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { map } from 'lodash';

import { DocumentRowWrapper } from './document-list';
import { useInstrument } from '../../features/instrument/instrument.ctx';

const DatesList = ({ name, ...restProps }) => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);
  const { instrumentListEn } = useInstrument();

  return (
    <Controller
      name={name}
      render={({ field }) => {

        if (field?.value) {
          setList(field.value)
        }

        const onChangeField = (changedObj, index) => {
          let tmp = [...list];
          tmp[index] = {
            ...tmp[index], ...changedObj
          }
          setList(tmp);
          field.onChange(tmp);
        }

        return (
          <Grid container>
            <Grid item xs={12}>
              <Grid container>
                <Grid item md={3} xs={12}>
                  {t("TYPE")}
                </Grid>
                <Grid item md={2} xs={12}>
                  {t("DATE")}
                </Grid>
                <Grid item md={3} xs={12}>
                  {t("DOCUMENT'S REFERENCE")}
                </Grid>
                <Grid item md={3} xs={12}>
                  {t("SUMMARY RECORD REFERENCE")}
                </Grid>
                <Grid item md={1} xs={12}>
                  {t("ACTIONS")}
                </Grid>
              </Grid>
            </Grid>
            {map(list, (e, i) => (
              <Grid item key={i} xs={12} mt={1}>
                <DocumentRowWrapper>
                  <Grid container>
                    <Grid item md={3} xs={12}>
                      <Select
                        value={list[i].type ? list[i].type.id : ""}
                        onChange={(e) => onChangeField({ type: { id: e.target.value } }, i)}
                        style={{ height: 32, width: "90%" }}
                      >
                        {map(instrumentListEn?.instrumentStatusUpdateTypes, d => (
                          <MenuItem key={d.id} value={d.id}>
                            {d.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </Grid>
                    <Grid item md={2} xs={12}>
                      <DesktopDatePicker
                        componentsProps={{
                          actionBar: {
                            actions: ['clear'],
                          },
                        }}
                        size="small"
                        inputProps={{ style: { fontSize: 12, width: 70 } }}
                        value={list[i].date || null}
                        onChange={(e) => {
                          if (e) {
                            onChangeField({ date: e.format('YYYY-MM-DD') }, i)
                          } else {
                            onChangeField({ date: null }, i)
                          }
                        }}
                        renderInput={(params) => <TextField size="small" {...params} />}
                      />
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <TextField
                        style={{ width: '90%' }}
                        inputProps={{ style: { fontSize: 12 } }}
                        size="small"
                        value={list[i].OLISRef && list[i].OLISRef[0]?.uri}
                        onChange={(e) => onChangeField({ OLISRef: [{ "format": "OLISRef", uri: e.target.value }] }, i)}
                      />
                      <Box sx={{ fontSize: 10 }}>
                        Add ONE references separated by commas
                      </Box>
                    </Grid>
                    <Grid item md={3} xs={12}>
                      <TextField
                        style={{ width: '90%' }}
                        inputProps={{ style: { fontSize: 12 } }}
                        size="small"
                        value={list[i].minutesOLISRef && list[i].minutesOLISRef[0]?.uri}
                        onChange={(e) => onChangeField({
                          minutesOLISRef: [{
                            "format": "OLISRef",
                            uri: e.target.value
                          }]
                        }, i)}
                      />
                      <Box sx={{ fontSize: 10 }}>
                        Add ONE references separated by commas
                      </Box>
                    </Grid>
                    <Grid item md={1} xs={12}>
                      <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <CloseIcon
                          sx={{ fontSize: 14, cursor: "pointer" }}
                          onClick={() => {
                            let tmp = [...list];
                            tmp.splice(i, 1)
                            setList(tmp);
                            field.onChange(tmp);
                          }}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </DocumentRowWrapper>
              </Grid>
            ))}
            <Grid item xs={12} mt={1}>
              <DocumentRowWrapper>
                <span
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    let tmp = [...list, {}];
                    field.onChange(tmp);
                  }}
                >
                  <AddIcon sx={{ fontSize: 14 }}/> add new line
                </span>
              </DocumentRowWrapper>
            </Grid>
          </Grid>
        )
      }}
    />
  )
};

export default DatesList;
